/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FixedPriceQuoteDetailsRequest } from './';
import {
    FixedPriceQuoteDetailsRequestFromJSON,
    FixedPriceQuoteDetailsRequestFromJSONTyped,
    FixedPriceQuoteDetailsRequestToJSON,
} from './';
import type { QuoteRequest } from './';
import {
    QuoteRequestFromJSON,
    QuoteRequestFromJSONTyped,
    QuoteRequestToJSON,
} from './';
import type { QuoteType } from './';
import {
    QuoteTypeFromJSON,
    QuoteTypeFromJSONTyped,
    QuoteTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface FixedPriceQuoteRequest
 */
export interface FixedPriceQuoteRequest extends QuoteRequest {
    /**
     * 
     * @type {FixedPriceQuoteDetailsRequest}
     * @memberof FixedPriceQuoteRequest
     */
    details: FixedPriceQuoteDetailsRequest;
}

/**
 * Check if a given object implements the FixedPriceQuoteRequest interface.
 */
export function instanceOfFixedPriceQuoteRequest(value: object): value is FixedPriceQuoteRequest {
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function FixedPriceQuoteRequestFromJSON(json: any): FixedPriceQuoteRequest {
    return FixedPriceQuoteRequestFromJSONTyped(json, false);
}

export function FixedPriceQuoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FixedPriceQuoteRequest {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...QuoteRequestFromJSONTyped(json, ignoreDiscriminator),
        'details': FixedPriceQuoteDetailsRequestFromJSON(json['details']),
    };
}

export function FixedPriceQuoteRequestToJSON(value?: FixedPriceQuoteRequest | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...QuoteRequestToJSON(value, true),
        'details': FixedPriceQuoteDetailsRequestToJSON(value['details']),
    };
}

